/**
 * Возвращает дату, смещенную на N дней назад
 */
export function getDateForNDaysAgo(daysAgo: number = 0, date: Date = new Date()) {
  return new Date(date.setDate(date.getDate() - daysAgo));
}
